import React from 'react';
import { useEffect } from "react";
import { useState } from "react";
import ProjectCard from "./ProjectCard";

const Project = () => {
  const [projectapi, setprojectapi] = useState([]);
  useEffect(() => {
    fetch("https://rahul-server.vercel.app/project")
      .then((res) => res.json())
      .then((data) => setprojectapi(data));
  }, []);


  return (
    <div className='grid lg:grid-cols-2 xl:grid-cols-3 mb-20 grid-cols-1 gap-4 md:grid-cols-2'>
      {projectapi.map((p) => (
        <ProjectCard key={p._id} p={p}> </ProjectCard>
      ))}
    </div>
  );
};

export default Project;